<template>
  <div class="bg-tempus-blue-900 text-white tempus-iframe-form" v-if="saleSurveyDivVisible" ref="paymentCardInput" id="payment_card_input">
    <div id="survey" class="container">
      <div class="row pb-2">
        <div class="col">
          <h3 class="font-mon mt-4 mb-2 text-center">Please help us with the following survey&hellip;</h3>
          <h5 class="font-mon mb-2 text-center">How did you hear about {{ location.brand }}?</h5>
          <h3 v-if="option" class="font-mon text-pink text-center mt-4 mb-2">Thank you for selecting {{ optionString }}</h3>

          <div class="mx-auto bg-tempus-blue-600" style="max-width: 30em;" ref="options">
            <div class="form-group px-4">
              <div class="row">
                <div class="col">
                  <template v-for="(survey, key) in saleSurveyStrings">
                    <div v-if="key != 'L'" class="form-check my-2"> <!-- ignore Google Plus -->
                      <label class="form-check-label" :for="$id('surveyOption'+key)">
                        <input
                          :id="$id('surveyOption'+key)"
                          class="form-check-input"
                          type="radio"
                          v-model="option"
                          :value="key">
                        <img v-if="key == 'T'" src="/img/logo/Stacked_TA_logo.png">
                        <img v-else-if="key == 'F'" src="/img/logo/icon-fb-opt.png">
                        <img v-else-if="key == 'I'" src="/img/logo/icon-instagram-opt.png">
                        <img v-else-if="key == 'W'" src="/img/logo/icon-twitter-opt.png">
                        {{ survey }}
                      </label>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
    saleSurveyStrings: {
      type: Object,
    },
  },

  data() {
    return {
      saleSurveyDivVisible: true,
      option: null,
    };
  },

  computed: {
    optionString() {
      if (this.option) {
        return this.saleSurveyStrings[this.option];
      }
    }

  },

  watch: {
    option(newOption) {
      if (newOption) {
        this.commitOption();
      }
    }
  },

  methods: {
    commitOption() {
      console.log()
      var request = {
        via: 'W',
        option: this.option,
      };

      this.loading(true); //refs.options

      axios.post(this.route('api.sales.surveys.store', this.sale), request)
        .then((response) => {
          if (response.status == 200) {
            console.log('commitOption axios back', response.data);
            // this.$emit('sale-updated', response.data);

          } else {
            flash('Error adding Option to Sale Survey', 'error');
            console.log('commitOption', response.data);
            console.log('commitOption', response.status);
            console.log('commitOption', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding Option to Sale Survey', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('commitOption:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('commitOption:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('commitOption:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('commitOption:401', error.response.data);
            } else {
              console.log('commitOption: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('commitOption: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('commitOption: Error', error.message);
          }
          this.loading(false);
        });
    }, // commitOption
  },

  mounted() {

  },
};
</script>
